import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
// Plugins
import { Observable } from 'rxjs';
import { SessionStorage, SessionStorageService } from 'ngx-webstorage';
// Models
import { LoginDTO, RefreshDTO } from '@models/auth/auth.model.dto';
import { AuthData, LoginRO, RefreshRo } from '@models/auth/auth.model.ro';
// Shared
import { APP_HOST, ENDPOINTS } from '@shared/endpoints.enum';
// Services
import { HttpService } from '@services/http/http.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService {

	@SessionStorage() public authData: AuthData;

	public constructor(
		private router: Router,
		private storageService: SessionStorageService,
		private httpServcice: HttpService
	) { }

	public login(data: LoginDTO): Observable<LoginRO> {
		return this.httpServcice.request('post', ENDPOINTS.LOGIN, APP_HOST.AUTH, data, true);
	}

	public refresh(data: RefreshDTO): Observable<RefreshRo> {
		return this.httpServcice.request('post', ENDPOINTS.REFRESH, APP_HOST.AUTH, data, true);
	}

	public logout(): void {
		this.storageService.clear();

		this.router.navigateByUrl('/login');
	}

	public canActivate(route: ActivatedRouteSnapshot): boolean {
		if (route.routeConfig.path == ENDPOINTS.LOGIN) {
			if (this.authData && this.authData.access_token && this.authData.refresh_token && this.authData?.user_data) {
				this.router.navigateByUrl('/');
	
				return false;
			}
		} else {
			if (!this.authData || !this.authData.access_token || !this.authData.refresh_token || !this.authData?.user_data) {
				this.router.navigateByUrl('/login');
				
				return false;
			}
		}

		return true;
	}
}